import { ThumbsUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCustomerRequestSearch } from '../hooks/useCustomerRequests';
import { CustomerRequestStatusBadge } from './CustomerRequestStatusBadge';
import type { CustomerRequestMatch } from '../types';

/** Likely existing requests for the title being typed, so the AM upvotes instead of duplicating. */
export function DuplicateMatches({ title, disabled, onUpvote }: {
  title: string;
  disabled?: boolean;
  onUpvote: (match: CustomerRequestMatch) => void;
}) {
  const { data } = useCustomerRequestSearch(title);
  const matches = title.trim().length >= 2 ? data?.matches ?? [] : [];
  if (!matches.length) return null;

  return (
    <section
      aria-label="Already requested?"
      className="rounded-md border border-amber-300 bg-amber-50 p-3 space-y-2 dark:border-amber-700 dark:bg-amber-950/30"
    >
      <p className="text-sm font-medium">Already requested?</p>
      {matches.map((m) => (
        <div key={m.id} className="flex items-center justify-between gap-2 text-sm">
          <div className="min-w-0 flex items-center gap-2">
            <span className="font-semibold tabular-nums">▲ {m.votes}</span>
            <span className="truncate">{m.title}</span>
            <CustomerRequestStatusBadge status={m.status} />
          </div>
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs shrink-0" disabled={disabled} onClick={() => onUpvote(m)}>
            <ThumbsUp className="h-3 w-3 mr-1" />
            Upvote this
          </Button>
        </div>
      ))}
    </section>
  );
}
